// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vr-z","response":"wr-z","error":"xr-z","disabled":"yr-z","buttons":"zr-z","feedbackQuestionSection":"Ar-z","yesNoWrapper":"Br-z"};